import { Alert } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { Fragment, useCallback, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-switch-lang';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import Breadcrumb from '../../../../breadcrumb';
import styles from '../../../../styles/style-setting.module.scss';
import CreateCommune from '../create-commune/create-commune';
import EditCommune from '../edit-commune/edit-commune';
import ActivityColumns from './table-header/activity-columns';

// number of activities per page
const NUMBER_OF_COMMUNES_PER_PAGE = 15;

const ListCommunesPage = (props) => {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [departements, setDepartements] = useState([]);
  const [selectedDepartement, setSelectedDepartement] = useState('');
  const [communes, setCommunes] = useState([]);
  const httpClient = useHttpClient(true);
  const [pageNumber, setPageNumber] = useState(0);
  const activityPerPage = NUMBER_OF_COMMUNES_PER_PAGE;
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  const keycloak = useKeycloak().keycloak;
  const [role, setRole] = useState('');
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);

  const [spinner, setSpinner] = useState({ state: false, id: '' });
  const pageCount = Math.ceil(
    (search === '' ? communes : communes.filter((activity) => activity.name.includes(search))).length / activityPerPage
  );
  const fetchCountries = () => {
    httpClient.current?.get(`/api/country/all`).then((response) => {
      setCountries(response.data);
    });
  };
  useEffect(() => {
    if (selectedCountry !== '') {
      httpClient.current?.get(`/api/region/all`).then((response) => {
        const regions = response.data.filter((region) => region.country.id == selectedCountry);
        setRegions(regions);
      });
    }
  }, [selectedCountry]);
  useEffect(() => {
    if (selectedRegion !== '') {
      httpClient.current?.get(`/api/departement/all`).then((response) => {
        const departements = response.data.filter((departement) => departement.region.id == selectedRegion);
        setDepartements(departements);
      });
    }
  }, [selectedRegion]);
  useEffect(() => {
    if (selectedCountry !== '') {
      getCommunes(selectedCountry, selectedRegion, selectedDepartement);
    } else {
      getCommunes();
    }
  }, [selectedRegion, selectedCountry, selectedDepartement,pageNumber]);
  const getCommunes = useCallback(
    (selectedCountry = '', selectedRegion = '', selectedDepartement = '') => {
      httpClient.current?.get(`/api/commune/all`).then((response) => {
        setCommunes(response.data);
        buildData(response.data, search, selectedCountry, selectedRegion, selectedDepartement);
      });
    },
    [httpClient]
  );

  const buildData = (newCommunes, searchCriteria, countryCreteria, regionCreteria, departementCreteria) => {
    const pagesVisited = pageNumber * NUMBER_OF_COMMUNES_PER_PAGE;
    const filteredBySearch = newCommunes.filter((activity) =>
      activity.name.toUpperCase().includes(searchCriteria.toUpperCase())
    );
    let filtred = countryCreteria
      ? filteredBySearch.filter((commune) => commune.departement.region.country.id == countryCreteria)
      : filteredBySearch;
    filtred = regionCreteria ? filtred.filter((commune) => commune.departement.region.id == regionCreteria) : filtred;
    filtred = departementCreteria
      ? filtred.filter((commune) => commune.departement.id == departementCreteria)
      : filtred;
    const restPagination = filtred.slice(pagesVisited, pagesVisited + activityPerPage);
    const newData = restPagination.map((commune) => {
      let action = (
        <div>
          <span>
            <EditCommune commune={commune} communes={getCommunes} />
          </span>
          <span>
            <DeleteButtonIcon
              title={props.t('delete_commune')}
              onClick={() =>
                SweetAlert.fire({
                  title: props.t('you_delete'),
                  text: props.t('not_recover'),
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: props.t('cancel'),
                  reverseButtons: true,
                }).then((result) => {
                  if (result.value) {
                    deleteCommune(commune.id);
                    SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                  } else {
                    SweetAlert.fire(props.t('isNotDeleted'));
                  }
                })
              }
              className={`fa fa-trash ${styles['trash']}`}
            />
          </span>
        </div>
      );
      let status =
        spinner.state === true && spinner.id === commune.id ? (
          <div className={`loader-box  ${styles['spinner']}`}>
            <div className="loader-2"></div>
          </div>
        ) : (
          <input
            type="checkbox"
            disabled={role === 'admin'}
            name="status"
            checked={commune?.valid}
            onChange={(e) => handleCheckBox(e, commune)}
          />
        );

      return {
        id: commune.id,
        name: commune.name,
        status: status,
        action: action,
      };
    });
    setData(newData);
  };

  const deleteCommune = async (countryId) => {
    await httpClient.current?.delete(`/api/commune/${countryId}`);
    getCommunes();
  };

  const handleCheckBox = async (event, activity) => {
    setSpinner({ state: true, id: activity.id });
    const activityValidation = { id: activity.id, name: activity.name, valid: event.target.checked };
    const response = httpClient.current?.put(`/api/country/update`, activityValidation);
    if ((await response).status === 200) {
      getCommunes();
      setSpinner({ state: false, id: activity.id });
    }
  };

  useEffect(() => {
    getCommunes();

    if (keycloak.authenticated) {
      keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER')
        ? setRole('super admin')
        : keycloak.hasResourceRole('ROLE_AGRISED_ADMIN')
        ? setRole('admin')
        : setRole('user');
    }
    fetchCountries();
  }, [getCommunes, keycloak]);

  useEffect(() => {
    getCommunes(selectedCountry, selectedRegion, selectedDepartement);
  }, [getCommunes, selectedCountry, selectedRegion, selectedDepartement, pageNumber]);

  useEffect(() => {
    buildData(communes, search,selectedCountry, selectedRegion, selectedDepartement);
  }, [communes, search, selectedCountry, selectedRegion, selectedDepartement, pageNumber]);

  const handleSearch = (event) => {
    setSearch(event.target.value);
    buildData(communes, event.target.value, selectedCountry, selectedRegion, selectedDepartement);
    changePage({ selected: 0 });
  };
  return (
    <div>
      <Fragment>
        <Breadcrumb parent={props.t('commune_url')} url={'settings/commune'} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <div className="float-right">
                    <CreateCommune communes={getCommunes} />
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="d-flex mb-2">
                    <input
                      className="form-control col-md-6 mr-2 "
                      onChange={handleSearch}
                      value={search}
                      placeholder={props.t('search_commune')}
                    />
                    <div className="flex-grow-1">
                      <select
                        className="form-control col-md-6 mb-2"
                        value={selectedCountry}
                        onChange={(event) =>
                          selectedRegion && selectedCountry == ''
                            ? setSelectedRegion('')
                            : setSelectedCountry(event.target.value)
                        }
                      >
                        <option value="">{props.t('all_countries')}</option>
                        {countries.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                      {selectedCountry !== '' && (
                        <select
                          className="form-control col-md-6 mb-2"
                          value={selectedRegion}
                          onChange={(event) => {
                            selectedDepartement && selectedRegion == ''
                              ? setSelectedDepartement('')
                              : setSelectedRegion(event.target.value);
                          }}
                        >
                          <option value="">{props.t('all_regions')}</option>
                          {regions.map((region) => (
                            <option key={region.id} value={region.id}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      )}
                      {selectedRegion !== '' && (
                        <select
                          className="form-control col-md-6 mb-2"
                          value={selectedDepartement}
                          onChange={(event) => setSelectedDepartement(event.target.value)}
                        >
                          <option value="">{props.t('all_departments')}</option>
                          {departements.map((departement) => (
                            <option key={departement.id} value={departement.id}>
                              {departement.name}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                  {data.length === 0 ? (
                    <Alert variant="outlined" severity="info">
                      {props.t('no_commune')}
                    </Alert>
                  ) : (
                    <ActivityColumns data={data} />
                  )}
                  <br />
                  <div className="float-right">
                    {communes.length > NUMBER_OF_COMMUNES_PER_PAGE && (
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={styles['paginationButton']}
                        previousLinkClassName={styles['previousBtn']}
                        nextLinkClassName={styles['nextBtn']}
                        disabledClassName={styles['paginationDisabled']}
                        activeClassName={styles['paginationActive']}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </div>
  );
};
export default translate(ListCommunesPage);
